import React, { useRef } from "react";
import styled from "styled-components";
import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { BackBarButtonMini } from "../../common/backBarButton";
import {
  PROFILE_COLORS,
  PROFILE_FONT_SIZES,
  PROFILE_SPACING,
  PROFILE_RADIUS,
  FONT_FAMILY,
} from "../styles/profileStyles";

// ============================================================================
// STYLED COMPONENTS
// ============================================================================

var ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: table;
  font-family: ${FONT_FAMILY};
`;

var ContentInner = styled.div`
  display: table-cell;
  vertical-align: top;
  padding: ${PROFILE_SPACING.lg} ${PROFILE_SPACING.xxl};
  padding-bottom: 0;
`;

var HeaderRow = styled.div`
  display: table;
  width: 100%;
  margin-bottom: ${PROFILE_SPACING.lg};
`;

var HeaderCell = styled.div`
  display: table-cell;
  vertical-align: middle;
`;

var PageTitle = styled.h4`
  color: ${PROFILE_COLORS.text};
  font-size: ${PROFILE_FONT_SIZES.title};
  font-weight: 700;
  margin: 0;
  margin-right: ${PROFILE_SPACING.md};
  display: inline-block;
`;

var ScrollContainer = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 150px);
`;

var TableContainer = styled.div`
  background: ${PROFILE_COLORS.cardBg};
  border-radius: ${PROFILE_RADIUS.lg};
  padding: ${PROFILE_SPACING.lg};
`;

var StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

var TableHead = styled.thead``;

var TableBody = styled.tbody``;

var TableRow = styled.tr`
  &:last-child td {
    border-bottom: none;
  }
`;

var TableHeader = styled.th`
  text-align: right;
  padding: ${PROFILE_SPACING.md};
  color: ${PROFILE_COLORS.text};
  font-size: ${PROFILE_FONT_SIZES.small};
  font-weight: 600;
  border-bottom: 1px solid dimgray;
`;

var TableCell = styled.td`
  text-align: right;
  padding: ${PROFILE_SPACING.md};
  color: ${PROFILE_COLORS.text};
  font-size: ${PROFILE_FONT_SIZES.small};
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`;

var MutedText = styled.span`
  color: ${PROFILE_COLORS.textMuted};
  margin-right: ${PROFILE_SPACING.xs};
`;

var EmptyState = styled.div`
  background: ${PROFILE_COLORS.cardBg};
  color: ${PROFILE_COLORS.text};
  padding: ${PROFILE_SPACING.lg};
  border-radius: ${PROFILE_RADIUS.lg};
  font-size: ${PROFILE_FONT_SIZES.body};
`;

// ============================================================================
// MAIN COMPONENT
// ============================================================================

var SubscriptionsContent = function (props) {
  var data = props.data;
  var { ref, focusKey } = useFocusable();
  var innerRef = useRef(null);

  return (
    <ContentWrapper>
      <ContentInner>
        <FocusContext.Provider value={focusKey}>
          <ScrollContainer ref={ref}>
            <HeaderRow>
              <HeaderCell>
                <BackBarButtonMini />
                <PageTitle>اشتراک های من</PageTitle>
              </HeaderCell>
            </HeaderRow>

            <div ref={innerRef}>
              {data && data.length > 0 ? (
                <TableContainer>
                  <StyledTable>
                    <TableHead>
                      <TableRow>
                        <TableHeader>ردیف</TableHeader>
                        <TableHeader>نوع</TableHeader>
                        <TableHeader>تاریخ</TableHeader>
                        <TableHeader>مبلغ</TableHeader>
                        <TableHeader></TableHeader>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.map(function (item, index) {
                        var orderType = item.orderType;
                        var createdAt = item.createdAt;
                        var amount = item.amount;
                        var subscriptionInfo = item.subscriptionInfo;
                        var _id = item._id;

                        return (
                          <TableRow key={_id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>
                              {orderType === "subscription"
                                ? "اشتراک"
                                : "سینما آنلاین"}
                            </TableCell>
                            <TableCell>
                              {new Date(createdAt).toLocaleString("fa")}
                            </TableCell>
                            <TableCell>
                              {amount ? amount.toLocaleString() : "-"}
                              <MutedText>تومان</MutedText>
                            </TableCell>
                            <TableCell>
                              {orderType === "subscription" &&
                                subscriptionInfo &&
                                subscriptionInfo.purchasedSubscription &&
                                subscriptionInfo.purchasedSubscription.name && (
                                  <span>
                                    {subscriptionInfo.purchasedSubscription.name}
                                    {" - "}
                                    {subscriptionInfo.purchasedSubscription.lifeTimeDays}
                                    <MutedText>روزه</MutedText>
                                  </span>
                                )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </StyledTable>
                </TableContainer>
              ) : (
                <EmptyState>
                  <p>موردی یافت نشد</p>
                </EmptyState>
              )}
            </div>
          </ScrollContainer>
        </FocusContext.Provider>
      </ContentInner>
    </ContentWrapper>
  );
};

export default SubscriptionsContent;
